import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import { Banana, Layers, History, LayoutDashboard, BookOpen, Settings as SettingsIcon } from 'lucide-react';
import Single from './pages/Single';
import Batch from './pages/Batch';
import HistoryPage from './pages/History';
import Documentation from './pages/Documentation';
import Settings from './pages/Settings';

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="app-container">
      <aside className="sidebar">
        <div className="logo">
          <div className="logo-icon">
            <Banana size={24} color="#fbbf24" />
          </div>
          <h1>Banana Veo</h1>
        </div>

        <nav>
          <NavLink to="/" className={({ isActive }: { isActive: boolean }) => `nav-item ${isActive ? 'active' : ''}`}>
            <LayoutDashboard size={20} />
            <span>Single Gen</span>
          </NavLink>
          <NavLink to="/batch" className={({ isActive }: { isActive: boolean }) => `nav-item ${isActive ? 'active' : ''}`}>
            <Layers size={20} />
            <span>Batch Gen</span>
          </NavLink>
          <NavLink to="/history" className={({ isActive }: { isActive: boolean }) => `nav-item ${isActive ? 'active' : ''}`}>
            <History size={20} />
            <span>History</span>
          </NavLink>
        </nav>

        <div className="nav-bottom">
          <NavLink to="/settings" className={({ isActive }: { isActive: boolean }) => `nav-item ${isActive ? 'active' : ''}`}>
            <SettingsIcon size={20} />
            <span>Settings</span>
          </NavLink>
          <NavLink to="/docs" className={({ isActive }: { isActive: boolean }) => `nav-item ${isActive ? 'active' : ''}`}>
            <BookOpen size={20} />
            <span>API Docs</span>
          </NavLink>
        </div>
      </aside>

      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Single />} />
          <Route path="/batch" element={<Batch />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/docs" element={<Documentation />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
